// This file was automatically generated from render.docMgr.html.
// Please don't edit this file by hand.

goog.provide('el8.template.render.docMgr');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.docMgr.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<ol class="docmgr-content el8SlidingPaneWrap"><li class="el8SlidingPaneItem organizer-content"><div class="organizer-section el8LargeLoading"><div class="tabbed-nav el8TabHomeSection"></div></div></li><li class="el8SlidingPaneItem sorter-content"><div class="sorter-section"></div></li><li class="el8SlidingPaneItem filer-content"><div class="filer-section"></div></li></ol><div class="docmgr-actions-content el8ShortcutBar el8FloatingContainer"><button type="button" class="el8SecondaryButton ebs-btn ebs-btn-default show-organizer-trigger m5">← Back</button><button type="button" class="el8SecondaryButton ebs-btn ebs-btn-default toggle-queue-btn m5">Show Queue</button></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.docMgr.notifyNew = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="notify-new el8NotificationBottomContainer"><span class="count-new">', soy.$$escapeHtml(opt_data.count), '</span> new document(s) arrived.<button type="button" data-action="refresh" class="ebs-btn ebs-btn-default">Refresh</button></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.docMgr.organizerDocumentButtons = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<ul class="button-list el8ButtonContainer" data-id="', soy.$$escapeHtml(opt_data.id), '">');
  var bList27685 = opt_data.buttons;
  var bListLen27685 = bList27685.length;
  for (var bIndex27685 = 0; bIndex27685 < bListLen27685; bIndex27685++) {
    var bData27685 = bList27685[bIndex27685];
    output.append('<li class="el8FloatingButtonItem">', (bData27685.action) ? '<button type="button" data-action="' + soy.$$escapeHtml(bData27685.action) + '" class="el8FloatingButton ebs-btn ebs-btn-default">' + soy.$$escapeHtml(bData27685.name) + '</button>' : '', '</li>');
  }
  output.append('</ul>');
  if (!opt_sb) return output.toString();
};
